export const TRACKING_TOGGLE_CHANGE = 'TRACKING_TOGGLE_CHANGE';
export const TRACKING_TOGGLE_CHANGE_SUCCESS = 'TRACKING_TOGGLE_CHANGE_SUCCESS';
export const TRACKING_TOGGLE_SAVE = 'TRACKING_TOGGLE_SAVE';
export const TRACKING_TOGGLE_SAVE_SUCCESS = 'TRACKING_TOGGLE_SUCCESS';
export const TRACKING_TOGGLE_SAVE_ERROR = 'TRACKING_TOGGLE_ERROR';

const trackingToggleChange = (name, active) => ({
  type: TRACKING_TOGGLE_CHANGE,
  name,
  active,
});
const trackingToggleSaveSuccess = (tracking, showSuccessPrompt = false) => ({
  type: TRACKING_TOGGLE_SAVE_SUCCESS,
  tracking,
  showSuccessPrompt,
});
const trackingToggleSaveError = tracking => ({
  type: TRACKING_TOGGLE_SAVE_ERROR,
  tracking,
});
const trackingToggleSave = (
  settings,
  isLoggedIn,
  showSuccessPrompt = false
) => ({
  type: TRACKING_TOGGLE_SAVE,
  settings,
  isLoggedIn,
  showSuccessPrompt,
});

export default {
  trackingToggleChange,
  trackingToggleSave,
  trackingToggleSaveSuccess,
  trackingToggleSaveError,
};
